/*
 * Remembers the circuit (jewelry or accessories) the visitor is browsing, in the cart attribute "circuito".
 * Shared pages (policies, 404, contact, account, empty or mixed cart) have no circuit of their own: the
 * theme renders them with the remembered one, see snippets/eva-circuit.liquid.
 *
 * Only pages that belong to a circuit write it, and only when it changed, so most visits make no request.
 */
(() => {
  const circuit = window.evaCircuit;
  if (!circuit || window.evaCircuitNeutral) return;

  const saved = window.evaCircuitSaved || '';
  // Jewelry is the default: nothing to store until the visitor has been to the accessories.
  if (circuit === saved || (circuit === 'joias' && !saved)) return;

  const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
  fetch(`${root}cart/update.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ attributes: { circuito: circuit } }),
  }).catch(() => {});
})();
